module.exports = __webpack_public_path__ + "static/AulaFree-Desk-1280x530-cf0508c727906b8872e3bb1d9e615a5c.png";